import { styled } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem';

import FontFamily from '../../../../Theme/FontFamily';
import Colours from '../../../../Theme/Colours';


export const Styles = {
  menu: {
    '& > div:nth-of-type(3)': {
      '&::-webkit-scrollbar': {
        background: "#ffffff29",
        width: "6px",
      },
      '&::-webkit-scrollbar-thumb': {
        background: "rgb(228 219 219)",
        borderRadius: "8px",
      },
    },
  },
};

export const StyledTrigger = styled('div', {
  shouldForwardProp: prop => prop !== 'disabled',
})<{ disabled?: boolean }>(({ disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  height: '100%',
  minWidth: 46,
  paddingLeft: 8,
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StyledTriggerLabel = styled('span')({
  fontFamily: FontFamily,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '21px',
  color: Colours.Typography.light,
  whiteSpace: 'nowrap',
});

export const StyledSearchContainer = styled('div')({
  padding: '4px 12px 8px',
  position: 'sticky',
  top: 0,
  backgroundColor: '#001326',
  zIndex: 1,
});

export const StyledSearchField = styled(InputBase)({
  width: '100%',
  padding: '2px 8px',
  borderRadius: 4,
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  input: {
    fontFamily: FontFamily,
    fontSize: 13,
    color: Colours.Typography.light,
    '&::placeholder': {
      color: 'rgba(255, 255, 255, 0.6)',
      opacity: 1,
    },
  },
});

export const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  fontFamily: FontFamily,
  fontSize: 13,
  color: Colours.Typography.light,
  '&.Mui-selected': {
    backgroundColor: 'rgba(255, 255, 255, 0.16)',
  },
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
});

export const StyledCountryName = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const StyledCallingCode = styled('span')({
  color: 'rgba(255, 255, 255, 0.7)',
  whiteSpace: 'nowrap',
});

export const StyledEmptyMessage = styled('div')({
  padding: '8px 16px',
  fontFamily: FontFamily,
  fontSize: 13,
  color: 'rgba(255, 255, 255, 0.7)',
});

export const MenuPaperStyles = {
  backgroundColor: '#001326',
  boxShadow: '0px 0px 1px rgb(255 255 255)',
  maxHeight: 260,
  width: 240,
  borderRadius: '6px'
};

export const MenuListStyles = {
  paddingTop: 0,
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
};
